import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import Founder from "./pages/Founder";
import History from "./pages/History";
import Philosophy from "./pages/Philosophy";
import Testimonials from "./pages/Testimonials";
import AdmissionProcess from "./pages/AdmissionProcess";
import ApplicationForm from "./pages/ApplicationForm";
import FAQ from "./pages/FAQ";
import AboutNIOS from "./pages/AboutNIOS";
import SubjectsOffered from "./pages/SubjectsOffered";
import TestPreparation from "./pages/TestPreparation";
import CounselingOffice from "./pages/CounselingOffice";
import CareerCounseling from "./pages/CareerCounseling";
import CareerDirection from "./pages/CareerDirection";
import Contact from "./pages/Contact";
import Disclaimer from "./pages/Disclaimer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="founder" element={<Founder />} />
          <Route path="history" element={<History />} />
          <Route path="philosophy" element={<Philosophy />} />
          <Route path="testimonials" element={<Testimonials />} />
          <Route path="admission-process" element={<AdmissionProcess />} />
          <Route path="application-form" element={<ApplicationForm />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="about-nios" element={<AboutNIOS />} />
          <Route path="subjects-offered" element={<SubjectsOffered />} />
          <Route path="test-preparation" element={<TestPreparation />} />
          <Route path="counseling-office" element={<CounselingOffice />} />
          <Route path="career-counseling" element={<CareerCounseling />} />
          <Route path="career-direction" element={<CareerDirection />} />
          <Route path="contact" element={<Contact />} />
          <Route path="disclaimer" element={<Disclaimer />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-conditions" element={<TermsConditions />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
